import { assessmentCategories, type AssessmentCategory } from "../shared/contracts";

export const assessmentSelectionKey = "yeyang.assessmentCategory";

export function parseAssessmentCategory(value: string | null): AssessmentCategory | null {
  return assessmentCategories.includes(value as AssessmentCategory) ? value as AssessmentCategory : null;
}

export function initialAssessmentCategory(): AssessmentCategory {
  const query = parseAssessmentCategory(new URLSearchParams(window.location.search).get("assessmentCategory"));
  if (query) return query;
  try {
    return parseAssessmentCategory(window.sessionStorage.getItem(assessmentSelectionKey)) || "STANDARD";
  } catch {
    return "STANDARD";
  }
}

export function rememberAssessmentCategory(category: AssessmentCategory) {
  try { window.sessionStorage.setItem(assessmentSelectionKey, category); } catch { /* The URL still retains the current selection when storage is unavailable. */ }
  const url = new URL(window.location.href);
  url.searchParams.set("assessmentCategory", category);
  window.history.replaceState(window.history.state, "", url);
}
